'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/IconSvg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var escapeKey = 27;

var StackView = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(StackView, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(StackView);

  function StackView() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, StackView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleEscKey", function (event) {
      if (event.keyCode === escapeKey) {
        _this.handleClose(event);
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClose", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onClose();
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(StackView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleEscKey);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleEscKey, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children,
          footer = _this$props.footer;
      return /*#__PURE__*/React__default['default'].createElement("aside", {
        className: "ds-stackview ".concat(this.props.className)
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: "title"
      }, /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: "close",
        onClick: this.handleClose
      }, /*#__PURE__*/React__default['default'].createElement(index, {
        className: "close-stack-view-icon",
        icon: "cross"
      })), title), /*#__PURE__*/React__default['default'].createElement("div", {
        className: "content"
      }, children), footer && /*#__PURE__*/React__default['default'].createElement("div", {
        className: "footer"
      }, footer));
    }
  }]);

  return StackView;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(StackView, "propTypes", {
  title: PropTypes__default['default'].node.isRequired,
  children: PropTypes__default['default'].node,
  footer: PropTypes__default['default'].node,
  onClose: PropTypes__default['default'].func,
  className: PropTypes__default['default'].string
});

_rollupPluginBabelHelpers.defineProperty(StackView, "defaultProps", {
  children: null,
  footer: null,
  className: '',
  onClose: function onClose() {}
});

module.exports = StackView;
